import React, { HTMLAttributes } from 'react'
import theme from 'presentation/styles/theme'
import * as S from './style'

export type CardProps = {
  children?: React.ReactNode
  style?: React.CSSProperties
  shadow?: 'none' | 'small' | 'medium' | 'large' | 'default'
  border?: 'none' | 'style1' | 'style2'
  radius?: keyof typeof theme.ds.typography.border.radius
  padding?: string
  background?: keyof typeof theme.ds.colors
  color?: keyof typeof theme.ds.colors
  gap?: string
  disabled?: boolean
  onClick?: () => void
  // hover?: boolean
} & HTMLAttributes<HTMLDivElement>

export default function CardNew({
  children,
  style,
  shadow = 'default',
  border = 'none',
  radius = 'small',
  background = 'white',
  color = 'neutral900',
  padding = '16px',
  gap,
  disabled,
  onClick,
  ...props
}: CardProps) {
  return (
    <S.CardWrapper
      style={style}
      shadow={shadow}
      gap={gap}
      border={border}
      radius={radius}
      background={background}
      color={color}
      padding={padding}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </S.CardWrapper>
  )
}
